import { ImageLinkEntity } from '@/services/types/globals.type';

export const eventPromotionBannerData: ImageLinkEntity[] = [
  {
    imgUrl: '/images/event/retest-license-fee/web_banner.webp',
    mobileImgUrl: '/images/event/retest-license-fee/mobile_banner.webp',
    label: '재시험비&면허증발급비 이벤트',
    href: '/event/retest-license-fee',
  },
];
